<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import { computed, onMounted } from 'vue';
import { useCommentsStore } from '@/stores/comments.store';
import { storeToRefs } from 'pinia';
import ReorderableTable from '@/components/ReorderableTable.vue';
import { getTranslation } from '@/composables/data-display-utils';

const { t } = useI18n();
const commentStore = useCommentsStore();
onMounted(() => {
  commentStore.fetchComments();
});
const { isLoaded } = storeToRefs(commentStore);
const comments = computed(() => commentStore.comments);
const columns = computed(() => [
  {
    name: 'title',
    label: t('community.title'),
    field: (row: any) => getTranslation(row.form.section.Consultation.Community, 'title'), // TODO: Add language enabled
    align: 'left',
  },
]);

function handleRowClick() {
  console.log('clicked');
}
</script>

<template>
  <q-page class="comment-moderation">
    <h1 class="title">{{ t('menu.commentModeration') }}</h1>
    <!--<error-banner :isError="consultations_error !== null" :error="consultations_error" />-->
    <reorderable-table
      v-if="isLoaded"
      :rows="comments"
      :columns="columns"
      :loading="false"
      itemKey="id"
      @row-click="handleRowClick"
      hideBottom
      :disableOrderable="true"
    />
  </q-page>
</template>

<style lang="scss">
.comment-moderation {
  padding: 16px;
  .title {
    margin: 0 10px !important;
  }
}
</style>
